import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGFormSender} from "vgformsender";
import {VGRollup} from "vgrollup";
import {VGSelect} from "vgselect";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.ScrollHeader.init($(window));
		VG.clone();

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollHeader.init($self);
		VG.ScrollToTop.setPosition($self);
	},

	onResize: ($self) => {
		VG.clone();
	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] img').each(function(){
				$(this).closest('a').attr('href', $(this).attr('src'));
			});
		});
	},

	clone: () => {
		if (window.innerWidth < 1199) {
			let $obj_filters_clone = $('.catalog-filters--clone');
			if ($obj_filters_clone.length) {
				$obj_filters_clone.clone(true).detach();
				$('.catalog-sidebar--clone-filters').append($obj_filters_clone)
			}

			let $obj_categories_clone = $('.catalog-categories--clone');
			if ($obj_categories_clone.length) {
				$obj_categories_clone.clone(true).detach();
				$('.catalog-sidebar--clone-categories').append($obj_categories_clone)
			}
		}
	},

	plugins: {
		init: () => {
			VG.plugins.enableVGSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableFormSender();
			VG.plugins.enableFormSendLoadings();
			VG.plugins.enableVGRollup();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'md',
				move: true,
				toggle: false,
				hover: true
			});
		},

		enableVGSelect: function ()  {
			let elements = document.querySelectorAll('select.vg-select');
			for (const element of elements) {
				new VGSelect(element)
			}
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableFormSender: function () {
			const $forms = document.querySelectorAll('[data-vgformsender]');
			if ($forms.length) {
				$forms.forEach(function (form) {
					new VGFormSender(form).submit();
				});
			}
		},

		enableFormSendLoadings: function () {
			$('form').submit(function () {
				let $btn = $(this).find('button[type=submit]');
				let textLoading = $btn.data('loading-text');
				if (textLoading) {
					$btn.text(textLoading).attr('disabled', 'disabled');
				}
			});
		},

		enableVGRollup: function () {
			let $rollups = document.querySelectorAll('[data-rollup-content]');
			if ($rollups.length) {
				for(let i = 1; i <= $rollups.length; i++) {
					let target = $rollups[i - 1].getAttribute('id'),
						content = $rollups[i - 1].dataset.rollupContent || 'text';

					new VGRollup(target, {
						content: content,
						buttonText: {
							more: 'Подробнее',
							less: 'Свернуть'
						},
					}, {
						afterShow: function () {
							// coming soon
						},
						afterHide: function () {
							// coming soon
						}
					});
				}
			}
		},
	},

	ScrollHeader: {
		lastScrollTop: 0,
		body: $('body'),
		stickyArea: $('.sticky-area'),
		height: {
			window: window.innerHeight,
			wrapper: $('.wrapper').height(),
			sticky: $('.header-wrapper').height()
		},

		init: function ($window) {
			let $sticky = $('.header-wrapper'),
				scroll = $window.scrollTop();

			if ((this.height.window + this.height.sticky + 50) > this.height.wrapper) return;

			if (scroll > 131) {
				this.body.addClass('header--is-scroll');
				$sticky.addClass('scroll');

				if (scroll > this.lastScrollTop) {
					$sticky.removeClass('fixed');
					this.body.removeClass('header--is-fixed');
					this.stickyArea.removeClass('fixed');
				} else {
					$sticky.addClass('fixed');
					this.body.addClass('header--is-fixed');
					this.stickyArea.addClass('fixed');
				}

				this.lastScrollTop = scroll;
			} else if (scroll < 131) {
				$sticky.removeClass('scroll').removeClass('fixed');
				this.body.removeClass('header--is-scroll header--is-fixed');
			}

			// widgets-sticky scroll
			let $widgetsSticky = $('.widgets-sticky, .sticky-top, .sticky-area');
			if ($widgetsSticky.length) {
				if(this.body.hasClass('header--is-fixed')) {
					$widgetsSticky.css('top', 84);
				} else {
					$widgetsSticky.css('top', 16);
				}
			}
		},
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	}
}


export default VGListener;
